<template>
<div>
  <div class="billing__section" v-if="this.paymentSection == 'amount'">
    <div class="css-grid pay-invoice-form__row pay-invoice-form__row--header">
      <div></div>
      <div class="pay-invoice-view__cell pay-invoice-view__cell--header">Payment Info</div>
      <div></div>
    </div>
    <div class="panel">
      <div class="css-grid pay-invoice-form__row">
        <div class="h-collapsible"></div>
        <div class="grid__col--12">
          <div class="form__item--row">
            <label class="form__label">Fuel Account # or Invoice Number(s) (if applicable):</label>
            <StoreConnectedInput store="payInvoice" name="invoiceNumber" :debounce="false" placeholder="Fuel Account # or Invoice Number(s) *"></StoreConnectedInput>
          </div>
        </div>
        <div class="h-collapsible"></div>
      </div>

      <div class="css-grid pay-invoice-form__row">
        <div class="h-collapsible"></div>
        <div class="grid__col--12">
          <div class="form__item--row">
            <label class="form__label">Payment Amount:</label>
            <StoreConnectedInputGroup store="payInvoice" name="amount" icon="usd" :debounce="false" placeholder="Payment Amount *"></StoreConnectedInputGroup>
          </div>
        </div>
        <div class="h-collapsible"></div>
      </div>

      <div class="css-grid pay-invoice-form__row">
        <div class="h-collapsible"></div>
        <div class="grid__col--12">
          <div class="form__item--row">
            <label class="form__label">Note (optional):</label>
            <StoreConnectedInput store="payInvoice" name="note" :debounce="false" placeholder="Note"></StoreConnectedInput>
          </div>
        </div>
        <div class="h-collapsible"></div>
      </div>

      <div class="css-grid pay-invoice-form__row">
        <div class="h-collapsible"></div>
        <div class="grid__col--12">
          <div class="form__item--row">
            <p class="h-italic-text h-center-align">* To apply payment to specific invoices, list all invoice numbers separated by a comma or space and enter the total payment amount.</p>
            <p class="h-italic-text h-center-align">* If no invoice number(s) are provided, payments will be automatically applied to the oldest open invoices.</p>
          </div>
        </div>
        <div class="h-collapsible"></div>
      </div>

      <div class="css-grid battery-order-form__row">
        <div class="h-collapsible"></div>
        <div>
          <div class="grid__col--2">
            &nbsp;
          </div>
          <div class="grid__col--8">
            &nbsp;
          </div>
          <div class="grid__col--2 h-right-align">
            <button class="btn btn-primary" @click.prevent="nextStep" :disabled="!amountValid">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Next&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</button>
          </div>
        </div>
        <div class="h-collapsible"></div>
      </div>

    </div> <!-- END panel -->
  </div> <!-- END section -->

  <div class="billing__section" v-if="this.paymentSection == 'billing'">
    <div class="css-grid pay-invoice-form__row pay-invoice-form__row--header">
      <div class="h-collapsible"></div>
      <div class="pay-invoice-view__cell pay-invoice-view__cell--header">Billing Info</div>
      <div class="h-collapsible"></div>
    </div>

    <div class="panel">
      <div class="css-grid pay-invoice-form__row">
        <div class="h-collapsible"></div>
        <div>
          <div class="grid__col--12">
            <div class="form__item--row">
              <label class="form__label">Card Holder Name (required)</label>
              <StoreConnectedInput :store="store" :action="action" name="paymentInfo" sub-prop="cardholderName" placeholder="Card Holder Name"></StoreConnectedInput>
            </div>
          </div>
        </div>
        <div class="h-collapsible"></div>
      </div>

      <div class="css-grid battery-order-form__row">
        <div class="h-collapsible"></div>
        <div>
          <label class="form__label">Billing Address:</label>
          <StoreConnectedInput :store="store" :action="action" name="billingInfo" sub-prop="street" :debounce="false" placeholder="Billing Address"></StoreConnectedInput>
        </div>
        <div class="h-collapsible"></div>
      </div>
      <div class="css-grid battery-order-form__row">
        <div class="h-collapsible"></div>
        <div>
          <div class="grid__col--7">
            <div class="form__item--row">
              <StoreConnectedInput :store="store" :action="action" name="billingInfo" sub-prop="city" :debounce="false" placeholder="City"></StoreConnectedInput>
            </div>
          </div>
          <div class="grid__col--2">
            <div class="form__item--row">
              <StoreConnectedSelect :store="store" :action="action" :options="states" name="billingInfo" sub-prop="state" placeholder="State"></StoreConnectedSelect>
            </div>
          </div>
          <div class="grid__col--3">
            <div class="form__item--row">
              <StoreConnectedInput :store="store" :action="action" name="billingInfo" sub-prop="zip" :debounce="false" placeholder="Zip Code"></StoreConnectedInput>
            </div>
          </div>
        </div>
        <div class="h-collapsible"></div>
      </div>

      <br><br>
      <div class="css-grid battery-order-form__row">
        <div class="h-collapsible"></div>
        <div>
          <div class="grid__col--2">
            <button class="btn btn-secondary" @click.prevent="prevStep">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Back&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</button>
          </div>
          <div class="grid__col--8">
            &nbsp;
          </div>
          <div class="grid__col--2 h-right-align">
            <button class="btn btn-primary" @click.prevent="nextStep" :disabled="!billingValid">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Next&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</button>
          </div>
        </div>
        <div class="h-collapsible"></div>
      </div>
      
    </div>
  </div> <!-- END section -->

  <div class="billing__section" v-show="this.paymentSection == 'cardinfo'">
    <ChartLoader v-if="loaders.tokenFetching"></ChartLoader>
    <div class="panel" v-show="!loaders.tokenFetching">
      <CreditCardForm></CreditCardForm>
    </div>

    <div v-if="this.errorMessage" class="css-grid pay-invoice-form__row pay-invoice-form__row--error">
      <div class="h-collapsible"></div>
      <div class="grid__col--12">
        <div class="form__item--row">
          Error: {{ this.errorMessage }}
        </div>
      </div>
      <div class="h-collapsible"></div>
    </div>
    
    <br><br>
    <div class="css-grid battery-order-form__row">
      <div class="h-collapsible"></div>
      <div>
        <div class="grid__col--2">
          <button class="btn btn-secondary" @click.prevent="prevStep">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Back&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</button>
        </div>
        <div class="grid__col--6">
          &nbsp;
        </div>
        <div class="grid__col--4 h-right-align">
          <button class="btn btn-primary" @click.prevent="submitPayment" :disabled="!formValid">Submit Payment</button>
        </div>
      </div>
      <div class="h-collapsible"></div>
    </div>
  </div> <!-- END section -->

</div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { MoonLoader } from 'vue-spinner/dist/vue-spinner.min.js';
  import StoreConnectedSelect from '../form-items/StoreConnectedSelect.vue';
  import StoreConnectedInput from '../form-items/StoreConnectedInput.vue'
  import StoreConnectedInputGroup from '../form-items/StoreConnectedInputGroup.vue'
  import CreditCardForm from './payment/CreditCardForm.vue';
  import ChartLoader from '../general/ChartLoader.vue'

  export default {
    name: 'PaymentView',
    components: {
      MoonLoader,
      StoreConnectedInput,
      StoreConnectedInputGroup,
      StoreConnectedSelect,
      CreditCardForm,
      ChartLoader,
    },
    data() {
      return {
        store: 'payInvoice',
        action: 'setObjectProperty',
        // page: 'amount',
        // pages: ['amount', 'billing', 'cardinfo'],
        gravityAssetsLoaded: false,
      };
    },
    computed: {
      ...mapGetters('payInvoice', ['paymentSection','paymentSections','paymentInfo', 'invoiceNumber', 'paymentAmount','gravityAssetsUrl','errorMessage','loaders']),
      ...mapGetters('batteryStore', ['states']),
      cardNumber() {
        return this.paymentInfo.cardNumber;
      },
      cardNumberValid() {
        return this.cardNumber !== null && this.cardNumber !== '';
      },
      cardholderName() {
        return this.paymentInfo.cardholderName;
      },
      cardholderNameValid() {
        return this.cardholderName !== null && this.cardholderName !== '';
      },
      expDate() {
        return this.paymentInfo.expDate;
      },
      expDateValid() {
        return this.expDate !== null && this.expDate !== '';
      },
      cvv() {
        return this.paymentInfo.cvv;
      },
      cvvValid() {
        return this.cvv !== null && this.cvv !== '';
      },
      paymentAmountValid() {
        return this.paymentAmount !== null && this.paymentAmount !== '' && this.paymentAmount > 0;
      },
      amountValid() {
        return  this.paymentAmountValid;
      },
      billingValid() {
        return  this.cardholderNameValid;
      },
      formValid() {
        return  this.cardholderNameValid &&
                this.paymentAmountValid;
                // And payment stuff entered
      },
    },
    watch: {
      paymentSection() {
        console.log("Page is "+this.paymentSection);
        if (this.paymentSection == 'cardinfo' && this.gravityAssetsLoaded) {
          this.getToken();
          this.clearValidationErrors();
        }
      }
    },
    methods: {
      nextStep() {
        let i = this.paymentSections.indexOf(this.paymentSection);
        if (i < (this.paymentSections.length - 1)) {
          //this.paymentSection = this.paymentSections[i+1];
          this.$store.dispatch('payInvoice/setProperty', {'key': 'paymentSection', 'value': this.paymentSections[i+1]});
        }
      },

      prevStep() {
        let i = this.paymentSections.indexOf(this.paymentSection);
        if (i > 0) {
          //this.paymentSection = this.paymentSections[i-1];
          this.$store.dispatch('payInvoice/setProperty', {'key': 'paymentSection', 'value': this.paymentSections[i-1]});
        }
      },

      submitPayment() {
        // Log payment submission on iFuel's side
        this.$store.dispatch('payInvoice/submitPayment');
      },

      getToken() {
        this.$store.dispatch('payInvoice/getToken');
      },

      clearValidationErrors() {
        this.$store.dispatch('payInvoice/setProperty', {'key': 'errorMessage', 'value': null});
      },

      fetchGravityJavascript() {
        //Append the Gravity assets to the header on the page.
        let gravityAssets = document.createElement('script')
        gravityAssets.setAttribute('src', this.gravityAssetsUrl+'/cip-hosted-fields.js');
        document.head.appendChild(gravityAssets);

        let self = this;
        gravityAssets.onload = function() {
          self.gravityAssetsLoaded = true;
          console.log("GravityPayments javascript file is loaded.");
          //self.getToken();
        };
      },

    },
    mounted() {
      //console.log('Mounted hook running');
      window.payStore = this.$store;

      this.fetchGravityJavascript();
    },
  };
</script>
